<template>
    <div>
      <h2 class="text-xl font-bold mb-4">Descripción del puesto</h2>
      <div class="mb-4">
        <label for="jobTitle" class="block text-gray-700 text-sm font-bold mb-2">Nombre del puesto:</label>
        <input type="text" id="jobTitle" v-model="jobTitle" class="w-full p-2 border rounded">
      </div>
      <div class="mb-4">
        <label for="requirements" class="block text-gray-700 text-sm font-bold mb-2">Requisitos:</label>
        <textarea id="requirements" v-model="requirements" class="w-full p-2 border rounded"></textarea>
      </div>
      <div class="mb-4">
        <label for="skills" class="block text-gray-700 text-sm font-bold mb-2">Habilidades:</label>
        <textarea id="skills" v-model="skills" class="w-full p-2 border rounded"></textarea>
      </div>
      <div class="mb-4">
        <label for="responsibilities" class="block text-gray-700 text-sm font-bold mb-2">Responsabilidades:</label>
        <textarea id="responsibilities" v-model="responsibilities" class="w-full p-2 border rounded"></textarea>
      </div>
    </div>
</template>
<script>
export default {
    props: ['setJobDescription','jobDescription'],
    data() {
        return {
            jobTitle: this.jobDescription.jobTitle,
            requirements: this.jobDescription.requirements,
            skills: this.jobDescription.skills,
            responsibilities: this.jobDescription.responsibilities
        }
    },
    watch:{
        jobTitle(newValue){
           this.setJobDescription({jobTitle:newValue})
        },
        requirements(newValue){
           this.setJobDescription({requirements:newValue})
        },
        skills(newValue){
           this.setJobDescription({skills:newValue})
        },
        responsibilities(newValue){
           this.setJobDescription({responsibilities:newValue})
        }
    }
}
</script>